<template>
  <SvgBase iconName="sensor" width="19" height="24" fill="none">
    <g clip-path="url(#clip0_6294_16576)">
      <path
        d="M2.16 12.5993C3.35294 12.5993 4.32 11.6322 4.32 10.4393C4.32 9.24636 3.35294 8.2793 2.16 8.2793C0.967065 8.2793 0 9.24636 0 10.4393C0 11.6322 0.967065 12.5993 2.16 12.5993Z"
        :fill="color"
      />
      <path
        d="M9.96979 10.4406C9.96624 9.59722 9.76109 8.76689 9.37143 8.01889C8.98177 7.27089 8.41892 6.62689 7.7298 6.14062L6.27979 7.58062C6.79028 7.8636 7.21575 8.27806 7.51199 8.78098C7.80823 9.2839 7.96445 9.85694 7.96445 10.4406C7.96445 11.0243 7.80823 11.5974 7.51199 12.1003C7.21575 12.6032 6.79028 13.0176 6.27979 13.3006L7.7298 14.7506C8.42029 14.2634 8.98399 13.6178 9.37372 12.8679C9.76344 12.1181 9.96783 11.2857 9.96979 10.4406Z"
        :fill="color"
      />
      <path
        d="M18.5999 10.44C18.5979 8.46184 18.173 6.50697 17.3538 4.70641C16.5345 2.90585 15.3399 1.3012 13.8499 0L12.4399 1.41C13.7447 2.52622 14.7923 3.91182 15.5106 5.47149C16.2288 7.03116 16.6007 8.72789 16.6007 10.445C16.6007 12.1621 16.2288 13.8588 15.5106 15.4185C14.7923 16.9782 13.7447 18.3638 12.4399 19.48L13.8499 20.89C15.3412 19.5877 16.5366 17.9814 17.3558 16.179C18.1751 14.3767 18.5993 12.4199 18.5999 10.44V10.44Z"
        :fill="color"
      />
      <path
        d="M14.2798 10.4403C14.2784 9.02937 13.9637 7.63635 13.3584 6.36182C12.7532 5.0873 11.8724 3.96307 10.7798 3.07031L9.35986 4.51031C10.2691 5.214 11.0052 6.11657 11.5116 7.14881C12.018 8.18105 12.2813 9.31555 12.2813 10.4653C12.2813 11.6151 12.018 12.7496 11.5116 13.7818C11.0052 14.8141 10.2691 15.7166 9.35986 16.4203L10.7798 17.8403C11.8764 16.9444 12.7594 15.8153 13.3649 14.5353C13.9703 13.2552 14.2829 11.8563 14.2798 10.4403V10.4403Z"
        :fill="color"
      />
    </g>
  </SvgBase>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component'
import SvgBase from './SvgBase.vue'

@Options({
  components: {
    SvgBase,
  },
  props: {
    color: {
      type: String,
      default: 'currentColor',
    },
  },
})
export default class IconSensor extends Vue {}
</script>
